var map = {
	"./1.png": [
		7045,
		45
	],
	"./10.png": [
		3489,
		489
	],
	"./11.png": [
		3544,
		544
	],
	"./12.png": [
		403,
		403
	],
	"./13.png": [
		8826,
		826
	],
	"./14.png": [
		3125,
		125
	],
	"./15.png": [
		236,
		236
	],
	"./16.png": [
		8711,
		711
	],
	"./17.png": [
		7374,
		374
	],
	"./18.png": [
		6265,
		265
	],
	"./19.png": [
		5088,
		88
	],
	"./2.png": [
		4942,
		942
	],
	"./20.png": [
		9116,
		116
	],
	"./21.png": [
		8533,
		533
	],
	"./22.png": [
		382,
		382
	],
	"./23.png": [
		9751,
		132
	],
	"./24.png": [
		8232,
		232
	],
	"./25.png": [
		2849,
		849
	],
	"./26.png": [
		3866,
		866
	],
	"./27.png": [
		2723,
		723
	],
	"./28.png": [
		6804,
		423
	],
	"./29.png": [
		7933,
		933
	],
	"./3.png": [
		3783,
		783
	],
	"./30.png": [
		8375,
		375
	],
	"./31.png": [
		62,
		62
	],
	"./32.png": [
		7413,
		413
	],
	"./33.png": [
		8316,
		316
	],
	"./34.png": [
		8483,
		483
	],
	"./35.png": [
		906,
		906
	],
	"./36.png": [
		1073,
		73
	],
	"./4.png": [
		4168,
		168
	],
	"./5.png": [
		8033,
		33
	],
	"./6.png": [
		6922,
		922
	],
	"./7.png": [
		1027,
		27
	],
	"./8.png": [
		804,
		804
	],
	"./9.png": [
		4701,
		701
	],
	"./blue_back.png": [
		9630
	],
	"./gray_back.png": [
		6161,
		161
	],
	"./green_back.png": [
		7751,
		751
	],
	"./purple_back.png": [
		8668,
		668
	],
	"./red_back.png": [
		7783,
		164
	],
	"./yellow_back.png": [
		830,
		830
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6477;
module.exports = webpackAsyncContext;